/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupRequest {
    getFixupPrototypeFunction() { return UserGroupRequest.fixupPrototype; }

    static newInstance(model: Partial<UserGroupRequest>): UserGroupRequest {
        let obj = Object.assign(new UserGroupRequest(), model);
        UserGroupRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupRequest>): UserGroupRequest {
        if (!model) return null;
        return UserGroupRequest.newInstance(<UserGroupRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupRequest) {
        if (!obj) return;

        models.UserGroupRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupRequest): boolean {
        Object.setPrototypeOf(obj, UserGroupRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The unique group name for the user group to be created.
     */
    group_name: string;

    /**
     * ID of tenants to assign to UserGroup
     */
    tenant_ids: Array<string>;

    /**
     * List of role IDs to assign to UserGroup
     */
    roles: Array<string>;

    /**
     * List of users IDs to assign to UserGroup
     */
    users: Array<string>;

}
